import * as api from '../../../clients/veranstaltungen';

import {Action} from '@ngrx/store';

export const POST_AUFGABE_FEHLERBILD_ENTFERNEN = '[VeranstaltungenModul] PostAufgabeFehlerbildEntfernen laden';
export const POST_AUFGABE_FEHLERBILD_ENTFERNEN_AUSFUEHREN = '[VeranstaltungenModul] PostAufgabeFehlerbildEntfernen ausführen';
export const POST_AUFGABE_FEHLERBILD_ENTFERNEN_ERFOLGREICH = '[VeranstaltungenModul] PostAufgabeFehlerbildEntfernen laden erfolgreich';
export const POST_AUFGABE_FEHLERBILD_ENTFERNEN_FEHLER = '[VeranstaltungenModul] PostAufgabeFehlerbildEntfernen Ladefehler';
export const POST_AUFGABE_FEHLERBILD_ENTFERNEN_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] PostAufgabeFehlerbildEntfernen nicht ausgeführt (evtl. Offline)';


export class PostAufgabeFehlerbildEntfernenAction implements Action {
    readonly type = POST_AUFGABE_FEHLERBILD_ENTFERNEN;
        constructor(public aufgabeBildRequest: api.AufgabeBildRequest, public optPayload: any = null) {}
    }
export class PostAufgabeFehlerbildEntfernenAusfuehrenAction implements Action {
    readonly type = POST_AUFGABE_FEHLERBILD_ENTFERNEN_AUSFUEHREN;
        constructor(public aufgabeBildRequest: api.AufgabeBildRequest, public optPayload: any = null) {}
    }
export class PostAufgabeFehlerbildEntfernenErfolgreichAction implements Action {
    readonly type = POST_AUFGABE_FEHLERBILD_ENTFERNEN_ERFOLGREICH;
        constructor(public payload: api.AufgabeIdentifier, public aufgabeBildRequest: api.AufgabeBildRequest, public optPayload: any = null) {}
    }
export class PostAufgabeFehlerbildEntfernenFehlerAction implements Action {
    readonly type = POST_AUFGABE_FEHLERBILD_ENTFERNEN_FEHLER;
        constructor(public payload: any, public aufgabeBildRequest: api.AufgabeBildRequest, public optPayload: any = null) {}
    }
export class PostAufgabeFehlerbildEntfernenNichtAusgefuehrtAction implements Action {
    readonly type = POST_AUFGABE_FEHLERBILD_ENTFERNEN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenCommandAufgabeFehlerbildEntfernenActions =
    PostAufgabeFehlerbildEntfernenAction
    | PostAufgabeFehlerbildEntfernenAusfuehrenAction
    | PostAufgabeFehlerbildEntfernenErfolgreichAction
    | PostAufgabeFehlerbildEntfernenFehlerAction
    | PostAufgabeFehlerbildEntfernenNichtAusgefuehrtAction
    ;
